import {
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  InputAdornment,
  IconButton,
  Typography,
} from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers";
import { InputWrapper, LabelStyle } from "../../styles/form";
import { FilterOption } from "../columnFilterTypes";

type Props = {
  label?: string;
  value: string[];
  onChange: (value: string[]) => void;
  options: FilterOption[];
  showLabel?: boolean;
  placeholder?: string;
};

const MultiSelectFilterField = ({
  label,
  value,
  onChange,
  options,
  showLabel = true,
  placeholder = "Select",
}: Props) => {
  return (
    <FormControl sx={{ ...InputWrapper, width: "100%" }}>
      {showLabel && label && <FormLabel sx={LabelStyle}>{label}</FormLabel>}
      <Select
        multiple
        value={value}
        onChange={(e) => onChange(e.target.value as string[])}
        fullWidth
        displayEmpty
        renderValue={
          value.length > 0
            ? (selected) =>
                (selected as string[])
                  .map(
                    (v) => options.find((o) => o.value === v)?.label ?? v,
                  )
                  .join(", ")
            : () => (
                <Typography sx={{ color: "#c1cccf" }}>{placeholder}</Typography>
              )
        }
        endAdornment={
          value.length > 0 ? (
            <InputAdornment sx={{ marginRight: "10px" }} position="end">
              <IconButton onClick={() => onChange([])} size="small">
                <ClearIcon />
              </IconButton>
            </InputAdornment>
          ) : undefined
        }
      >
        {options.length > 0 ? (
          options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))
        ) : (
          <MenuItem value="" disabled>
            No options available
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default MultiSelectFilterField;
